import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';
import { ICustomerLastUnitsRepository } from 'shared/domain/repositories';
import { IVectisUnit, Unit } from 'shared/infra/adapters';

export default class VectisCustomerLastUnitsRepository
  implements ICustomerLastUnitsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public findById: ICustomerLastUnitsRepository['findById'] = async ({
    customerId,
    searchType,
  }) => {
    const typeUrlDictionary: Record<typeof searchType, string> = {
      INTERACTION: 'ultimaUnidadeAcaoCliente',
      SESSION: 'ultimaUnidade',
    };

    const urlEnd = typeUrlDictionary[searchType];

    const result = await this.httpProvider.get<IVectisUnit | null>(
      `clientes/${customerId}/${urlEnd}`,
    );

    if (result) return new Unit(result);

    return null;
  };
}
